import React from 'react';
import * as actions from '../redux/actions';
import _ from 'lodash';
import { KIOSK_TAG } from '../Constants';

class KioskUpdateBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleRemoveFromUpdate = this.handleRemoveFromUpdate.bind(this);
  }

  handleRemoveFromUpdate() {
    let { dispatch, kiosk } = this.props;
    dispatch(actions.unselectHostInfoId(kiosk.id));
  }

  render() {
    let { kiosk, result, inProgress, selectedKVS, showMoreInfo, onViewKioskUpdateHistory } =
      this.props;
    let hasError = /error code/.test(result);
    let online = /ONLINE/i.test(kiosk.sosdbKioskStatus);
    let offline = /OFFLINE/i.test(kiosk.sosdbKioskStatus);
    let samePrintapi = sameVersion(kiosk.printapiVersion, selectedKVS.printapi);
    let samePayapi = sameVersion(kiosk.payapiVersion, selectedKVS.payapi);
    let sameKskapi = sameVersion(kiosk.kskapiVersion, selectedKVS.kskapi);
    let sameCapui = sameVersion(kiosk.capuiVersion, selectedKVS.capui);
    let sameHeatwave =
      _.isEmpty(selectedKVS.heatwave) || sameVersion(kiosk.heatwaveVersion, selectedKVS.heatwave);
    let sameLinuxdash =
      _.isEmpty(selectedKVS.linuxdash) || sameVersion(kiosk.linuxdashVer, selectedKVS.linuxdash);
    let sameKioskprobe =
      _.isEmpty(selectedKVS.kioskprobe) ||
      sameVersion(kiosk.kioskprobeVersion, selectedKVS.kioskprobe);
    let sameCafeapi =
      _.isEmpty(selectedKVS.cafeapi) || sameVersion(kiosk.cafeapiVersion, selectedKVS.cafeapi);
    let sameVersions = false;
    if (
      samePrintapi &&
      samePayapi &&
      sameCapui &&
      sameKskapi &&
      sameHeatwave &&
      sameLinuxdash &&
      sameKioskprobe &&
      sameCafeapi
    ) {
      sameVersions = true;
    }

    let noTag = _.isEmpty(kiosk.sosdbTag);
    let prodTest = kiosk.sosdbTag === KIOSK_TAG.PROD_TEST;
    let checkBeforeUpdate = kiosk.sosdbTag === KIOSK_TAG.CHECK_BEFORE_UPDATE;
    let earlyUpdate = kiosk.sosdbTag === KIOSK_TAG.EARLY_UPDATE;
    let tempBeta = kiosk.sosdbTag === KIOSK_TAG.TEMP_BETA;
    let doNotUpdate = kiosk.sosdbTag === KIOSK_TAG.DO_NOT_UPDATE;
    let custom =
      !noTag && !prodTest && !checkBeforeUpdate && !earlyUpdate && !tempBeta && !doNotUpdate;

    return (
      <div
        className='pure-u-1 results-row'
        style={{ borderLeft: sameVersions ? '5px solid green' : '5px solid red' }}
      >
        <div className='label' style={{ borderLeft: 0 }}>
          {noTag && <span className='fa fa-fw fa-tag color-aux' title='No Tag' />}
          {prodTest && <span className='fa fa-fw fa-tag color-success' title={kiosk.sosdbTag} />}
          {checkBeforeUpdate && (
            <span className='fa fa-fw fa-tag color-primary' title={kiosk.sosdbTag} />
          )}
          {earlyUpdate && <span className='fa fa-fw fa-tag color-accent' title={kiosk.sosdbTag} />}
          {tempBeta && (
            <span className='fa fa-fw fa-tag color-deepskyblue' title={kiosk.sosdbTag} />
          )}
          {doNotUpdate && <span className='fa fa-fw fa-tag color-danger' title={kiosk.sosdbTag} />}
          {custom && <span style={{ fontSize: 10 }}>{kiosk.sosdbTag}</span>}

          {online && <i style={{ color: 'green' }} className='fa fa-fw fa-arrow-up' />}
          {offline && <i style={{ color: 'red' }} className='fa fa-fw fa-arrow-down' />}
          {!online && !offline && <i style={{ color: 'gray' }} className='fa fa-fw fa-minus' />}
          <span style={{ marginRight: '10px' }}> {kiosk.ip}</span>
          {!inProgress ? (
            <a
              style={{ marginRight: '10px', fontSize: 14 }}
              href='javascript:void(0)'
              onClick={onViewKioskUpdateHistory}
            >
              {kiosk.kioskName}
            </a>
          ) : (
            <span style={{ marginRight: '10px', fontSize: 14 }}>{kiosk.kioskName}</span>
          )}
          <span style={{ fontSize: 12, opacity: 0.6, paddingRight: 5 }}>loc:</span>
          <span style={{ marginRight: '10px' }}>{kiosk.locationName}</span>
          <span style={{ fontSize: 12, opacity: 0.6, paddingRight: 5 }}>org:</span>
          <span style={{ marginRight: '10px' }}>{kiosk.orgName}</span>
          <span style={{ marginRight: '10px', fontSize: 14 }}>(Matches: {kiosk.kvsNames})</span>
        </div>
        <div className='label-end'>
          {inProgress && hasError ? (
            <i className='fa fa-fw fa-times-circle' />
          ) : !inProgress && result ? (
            <i className='fa fa-fw fa-check-circle' />
          ) : (
            inProgress && <i className='fa fa-fw fa-refresh fa-spin' />
          )}

          {!inProgress && !result && (
            <a
              style={{ fontSize: 12 }}
              href='javascript:void(0)'
              onClick={this.handleRemoveFromUpdate}
            >
              remove
            </a>
          )}
        </div>

        {showMoreInfo && (
          <div className='pure-u-1' style={{ paddingLeft: 20, fontSize: 12 }}>
            <div className='pure-u-3-24' style={{ color: samePrintapi ? '' : 'red' }}>
              <span className='kvs-em'>printapi</span>
              <br /> {kiosk.printapiVersion}
            </div>
            <div className='pure-u-3-24' style={{ color: samePayapi ? '' : 'red' }}>
              <span className='kvs-em'>payapi</span>
              <br /> {kiosk.payapiVersion}
            </div>
            <div className='pure-u-3-24' style={{ color: sameCapui ? '' : 'red' }}>
              <span className='kvs-em'>capui</span>
              <br /> {kiosk.capuiVersion}
            </div>
            <div className='pure-u-3-24' style={{ color: sameKskapi ? '' : 'red' }}>
              <span className='kvs-em'>kskapi</span>
              <br /> {kiosk.kskapiVersion}
            </div>
            <div className='pure-u-3-24' style={{ color: sameCafeapi ? '' : 'red' }}>
              <span className='kvs-em'>cafeapi</span>
              <br /> {kiosk.cafeapiVersion}
            </div>
            {kiosk.heatwaveVersion && (
              <div className='pure-u-3-24' style={{ color: sameHeatwave ? '' : 'red' }}>
                <span className='kvs-em'>heatwave</span>
                <br /> {kiosk.heatwaveVersion}
              </div>
            )}
            {kiosk.linuxdashVer && (
              <div className='pure-u-3-24' style={{ color: sameLinuxdash ? '' : 'red' }}>
                <span className='kvs-em'>linuxdash</span>
                <br /> {kiosk.linuxdashVer}
              </div>
            )}
          </div>
        )}

        {result && <pre>{result}</pre>}
      </div>
    );
  }
}

function sameVersion(v1 = '', v2 = '') {
  // strip 'v' from the front and compare as old service like smtkms doesn't have 'v' in front of version
  return v1.replace(/^v/, '') === v2.replace(/^v/, '');
}

export default KioskUpdateBlock;



// WEBPACK FOOTER //
// ./src/components/KioskUpdateBlock.js